import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../config';
import { CloudLynk, SubscriptionInfo } from './subscription.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/subscription');

export const getFeedSubscriptionExpiration = actionCreator.async<void, SubscriptionInfo[]>('GET_APP_SUBSCRIPTIONS');
export const getClDevices = actionCreator.async<void, CloudLynk[]>('GET_CL_DEVICES');
